/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfListOfNameValueDto } from "../models/AjaxResponseOfListOfNameValueDto";

import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";

export class CarroSpAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * @returns AjaxResponseOfListOfNameValueDto
   * @throws ApiError
   */
  public getColors(): CancelablePromise<AjaxResponseOfListOfNameValueDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/carrosp/get-colors",
    });
  }

  /**
   * @returns AjaxResponseOfListOfNameValueDto
   * @throws ApiError
   */
  public getFuelTypes(): CancelablePromise<AjaxResponseOfListOfNameValueDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/carrosp/get-fuel-types",
    });
  }

  /**
   * @returns AjaxResponseOfListOfNameValueDto
   * @throws ApiError
   */
  public getMakes(): CancelablePromise<AjaxResponseOfListOfNameValueDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/carrosp/get-makes",
    });
  }

  /**
   * @returns AjaxResponseOfListOfNameValueDto
   * @throws ApiError
   */
  public getModels({
    makeId,
  }: {
    makeId?: string;
  }): CancelablePromise<AjaxResponseOfListOfNameValueDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/carrosp/get-models",
      query: {
        makeId: makeId,
      },
    });
  }

  /**
   * @returns AjaxResponseOfListOfNameValueDto
   * @throws ApiError
   */
  public getVersions({
    makeId,
    modelId,
  }: {
    makeId?: string;
    modelId?: string;
  }): CancelablePromise<AjaxResponseOfListOfNameValueDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/carrosp/get-versions",
      query: {
        makeId: makeId,
        modelId: modelId,
      },
    });
  }

  /**
   * @returns AjaxResponseOfListOfNameValueDto
   * @throws ApiError
   */
  public getMakesMotorcycle(): CancelablePromise<AjaxResponseOfListOfNameValueDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/carrosp/get-motorcycle-makes",
    });
  }

  /**
   * @returns AjaxResponseOfListOfNameValueDto
   * @throws ApiError
   */
  public getModelsMotorcycle({
    makeId,
  }: {
    makeId?: string;
  }): CancelablePromise<AjaxResponseOfListOfNameValueDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/carrosp/get-motorcycle-models",
      query: {
        makeId: makeId,
      },
    });
  }

  /**
   * @returns AjaxResponseOfListOfNameValueDto
   * @throws ApiError
   */
  public getVersionsMotorcycle({
    makeId,
    modelId,
  }: {
    makeId?: string;
    modelId?: string;
  }): CancelablePromise<AjaxResponseOfListOfNameValueDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/carrosp/get-motorcycle-versions",
      query: {
        makeId: makeId,
        modelId: modelId,
      },
    });
  }
}
